import React, { useState } from "react";
import { getPlanCardText, PLAN_TYPE } from "../../utils/api-pricing";
import { API_DIRECTORY_THEME } from "../../utils/constants";
import { IconArrowCascadeRight } from "cdk-radial";
let cf = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 4,
  minimumFractionDigits: 2,
});
let nf = new Intl.NumberFormat();

const PLAN_CARD_TEXT = getPlanCardText(API_DIRECTORY_THEME.ISV_API_DIRECTORY);

const displayTieredRatePlan = (ratePlan) => {
  const tiers = ratePlan.rates ? ratePlan.rates : ratePlan.tiers;
  const gridStyle =
    tiers.length >= 5 ? "repeat(5, 1fr)" : `repeat(${tiers.length}, 1fr)`;
  return (
    <div>
      <div className="api-dir-pkg_rate-plan container">
        <div className="api-dir-pkg_rate-plan api-dir-pkg_heading">
          {PLAN_CARD_TEXT[PLAN_TYPE.TRANSACTIONAL].heading}
        </div>
        <div className="api-dir-pkg_rate-plan api-dir-pkg_sub-heading">
          {PLAN_CARD_TEXT[PLAN_TYPE.TRANSACTIONAL].subtext}
        </div>
      </div>
      <div
        className="api-dir-pkg_transaction-plan-wrapper"
        style={{ gridTemplateColumns: gridStyle }}
      >
        {tiers.map((rateItem, idx) => {
          let rate =
            rateItem.rate || rateItem.rate === 0
              ? rateItem.rate
              : rateItem.pricePerRequest;
          return (
            <div className="api-dir-pkg_rate-plan-card" key={idx}>
              <div className="rate">${cf.format(rate)} / Call</div>
              <div className="details">
                {nf.format(rateItem.startUnit)}-
                {rateItem.endUnit ? nf.format(rateItem.endUnit) : "Unlimited"}{" "}
                Calls / Month
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
const displayFreePlan = () => {
  return (
    <div>
      <div className="api-dir-pkg_rate-plan container">
        <div className="api-dir-pkg_rate-plan api-dir-pkg_heading">
          {PLAN_CARD_TEXT[PLAN_TYPE.FREE].heading}
        </div>
        <div className="api-dir-pkg_rate-plan api-dir-pkg_sub-heading">
          {PLAN_CARD_TEXT[PLAN_TYPE.FREE].subtext}
        </div>
      </div>
      <div className="api-dir-pkg_rate-plan-card">
        <div className="rate">$0 / Month</div>
        <div className="details">Unlimited Calls / Month</div>
      </div>
    </div>
  );
};

const displayLegacyPlans = (planType, plan, allEndpoints) => {
  if (planType.toLowerCase() === PLAN_TYPE.TRANSACTIONAL) {
    return displayTieredRatePlan(plan);
  } else if (planType.toLowerCase() === PLAN_TYPE.SUBSCRIPTION) {
    return displaySubscriptionLocationPlanTile({ plan });
  } else if (planType.toLowerCase() === PLAN_TYPE.FREE) {
    return displayFreePlan();
  } else {
    return null;
  }
};

export const displaySubscriptionLocationPlanTile = ({ plan }) => {
  return (
    <div className="api-dir-pkg_isv-tile">
      <div className="api-dir-pkg_isv-plan-title">Subscription</div>

      <div className="api-dir-pkg_isv-plan-pricing">
        <span className="api-dir-pkg_isv-price-amount">
          ${plan.subscriptionPrice}
        </span>
        <span className="api-dir-pkg_isv-price-slash"> / </span>
        <span className="api-dir-pkg_isv-price-location">Location</span>
      </div>

      <div className="api-dir-pkg_isv-plan-frequency">per Month</div>

      <div className="api-dir-pkg_isv-plan-description">
        Monthly plan for unlimited API use per dealership location. Flat rate.
      </div>

      <div className="api-dir-pkg_isv-endpoint-container">
        <div className="api-dir-pkg_isv-endpoint-content">
          <div className="api-dir-pkg_isv-endpoint-title">All Endpoints</div>
          <div className="api-dir-pkg_isv-endpoint-details">
            Unlimited calls per month
            <br />
            No overage fees
          </div>
        </div>
      </div>
    </div>
  );
};

export { displayLegacyPlans };
